<template>
  <button
    :type="type"
    class="cta cta--primary"
    :class="{ 'cta--loading': loading, 'cta--block': block }"
    :disabled="disabled || loading"
    @click="$emit('click', $event)"
  >
    <span v-if="loading" class="cta__spinner" aria-hidden="true" />
    <span class="cta__label" :class="{ 'cta__label--dim': loading }">
      <slot />
    </span>
  </button>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  loading?: boolean;
  block?: boolean;
}>(), { type: 'button', block: true });

defineEmits<{ click: [MouseEvent] }>();
</script>

<style scoped lang="scss">
.cta {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 22px;
  border-radius: var(--radius-pill);
  font-weight: 600;
  font-size: 14.5px;
  letter-spacing: 0.3px;
  border: none;
  cursor: pointer;
  transition: opacity var(--dur-fast) var(--ease-out), transform var(--dur-fast) var(--ease-out);
  min-height: 48px;

  &:active:not(:disabled) { transform: scale(0.98); }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
}

.cta--block { width: 100%; }

.cta--primary {
  background: var(--grad-gold);
  color: var(--text-inverse);
}

.cta__label--dim { opacity: 0; }

.cta__spinner {
  position: absolute;
  width: 18px;
  height: 18px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: cta-spin 0.6s linear infinite;
}

@keyframes cta-spin {
  to { transform: rotate(360deg); }
}
</style>
